// "My AI Redacts Your Secrets Before the LLM Sees Them" — PII redaction short.
// Cold Compute / Neon kit. ~140s @ 30fps. 8 scenes.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames @30fps; contiguous.
// Each scene duration ≈ round((lastCaption.fromSec + 6) * 30) so the last
// caption shows ~6s before the slide changes (captions are sticky — no cut-off).
export const SCENE = {
  hook: { start: 0, duration: 360 }, //        0:00–0:12  the failure: PII would reach the model
  problem: { start: 360, duration: 390 }, //   0:12–0:25  retrieved chunks carry secrets
  detector: { start: 750, duration: 540 }, //  0:25–0:43  what the regex detector catches
  validate: { start: 1290, duration: 540 }, // 0:43–1:01  Luhn + SSN validation cut false positives
  where: { start: 1830, duration: 540 }, //    1:01–1:19  WHERE it runs: context + output
  redact: { start: 2370, duration: 390 }, //   1:19–1:32  how it redacts (mask / partial)
  honest: { start: 2760, duration: 390 }, //   1:32–1:45  honesty: regex limits, fail-open
  outro: { start: 3150, duration: 360 }, //    1:45–1:57
} as const;

export const TOTAL_DURATION = 3510; // 117s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
